<template src="./paladin-limit.html"></template>

<script>
import Multiselect from "vue-multiselect";
import PaladinGroupLookup from "../grouplookup/paladin-group-lookup";
import PaladinFilterSet from "../filterset/paladin-filterset";

import { ChiRhosNext } from "@paladin/core";

const ChiRhosNextApi = new ChiRhosNext().api();

// import _ from 'lodash'

// let ChiRhosApi = new ChiRhos().api()
// var eventApi = new EventApi(ChiRhosApi)
// var eventSeriesApi = new EventSeriesApi(ChiRhosApi)
// var eventTypeApi = new EventTypeApi(ChiRhosApi)

// var groupApi = new GroupApi(ChiRhosApi)
// var personApi = new PersonApi(ChiRhosApi)

export default {
  name: "PaladinLimit",
  components: { Multiselect, PaladinGroupLookup, PaladinFilterSet },
  props: {
    allRoles: {
      type: Array,
      required: true
    },
    groupTypes: {
      type: Array,
      default: null
    },
    id: {
      type: String,
      default: null
    },
    preset: {
      type: Object,
      default: null,
    }
  },
  data() {
    return {
      advancedFilter: false,
      filters: {},
      relationshipRequirements: [],
      relationshipMinimum: null,
      relationshipMaximum: null,
      relationshipOption: null,
      limit: {},
      scope: "everyone",
      include: "current",
      selectedRoles: [],
      selectedGroups: [],
      relationshipTypes: [],
      uniqueId: this.generateUUID(),
      presetFilterSet: null,
    };
  },
  computed: {
    isOpen: function() {
      let _return = true;

      switch (this.scope) {
        case "everyone":
          _return = true;
          break;
        case "update":
          _return = false;
          break;
        case "any":
          _return = false;
          break;
        case "only":
          _return = false;
          break;
        default:
          _return = false;
          break;
      }

      return _return;
    },
    relationshipTypeOptions: function() {
      var options = this.relationshipTypes.map(function(e) {
        return {
          value: 'f' + e.entity.entityId,
          text: 'a ' + e.entity.forwardsDescription + ' to a ' + e.entity.reverseDescription,
        }
      })

      options = options.concat(this.relationshipTypes.map(function(e) {
        return {
          value: 'r' + e.entity.entityId,
          text: 'a ' + e.entity.reverseDescription + ' to a ' + e.entity.forwardsDescription,
        }
      }))

      return options.concat(this.relationshipTypes.map(function(e) {
        return {
          value: '-' + e.entity.entityId,
          text: 'either ' + e.entity.reverseDescription + ' or a ' + e.entity.forwardsDescription,
        }
      }))
    },
  },
  watch: {
    scope: function(val) {
      this.setLimit();
    },
    selectedRoles: function(val) {
      this.setLimit();
    },
    selectedGroups: function(val) {
      this.setLimit();
    },
    include: function(val) {
      this.setLimit();
    },
    filters: function(val) {
      this.setLimit();
    },
    relationshipRequirements: function(val) {
      this.setLimit();
    },
    $props: {
      handler() {
        this.init();
      },
      deep: true,
      immediate: true
    }
  },
  created: function() {},
  mounted() {
    this.$nextTick(function() {
      this.init();
    });
  },
  methods: {
    init() {
      ChiRhosNextApi.RelationshipTypeApi.list({
        }).then(
          response => {
            if(response.data) this.relationshipTypes = response.data
            let getRelationshipOption = this.getRelationshipOption
            this.relationshipRequirements.forEach(function(e) {
              if(e.isFrom === null)
              {
                e.option = getRelationshipOption('-' + e.relationshipTypeEntityId)
              }
              else if(e.IsFrom)
              {
                e.option = getRelationshipOption('f' + e.relationshipTypeEntityId)
              }
              else
              {
                e.option = getRelationshipOption('r' + e.relationshipTypeEntityId)
              }
            })
          },
          error => {
            console.error(error)
            error.json().then(body => {
              this.$toast(body.Message, "error")
            })
          }
        )
      // bind any existing limit

      this.advancedFilter = false
      this.filters = {}
      this.relationshipRequirements = []
      this.relationshipMinimum = null
      this.relationshipMaximum = null
      this.relationshipOption = null
      this.limit = {}
      this.include = "current"
      this.selectedRoles = []
      this.selectedGroups = []
      this.relationshipTypes = []
      this.presetFilterSet = null

      if (!this.preset || this.preset === null) {
        this.scope = "update";

      } else {
        // we have a preset

        if (this.preset.isOpen) {
          this.scope = "everyone";
        }

        if (this.preset.roleLimit && this.preset.roleLimit !== null) {
          // we have a role limit

          if (this.preset.roleLimit.filters || this.preset.roleLimit.relationships) {
            // we have an advanced filter

            let generateUUID = this.generateUUID

            this.advancedFilter = true;
            if(this.preset.roleLimit.relationships) this.relationshipRequirements = this.preset.roleLimit.relationships.map(function(e) {
              e.id = generateUUID()
              return e
            })
            if(this.preset.roleLimit.filters)
            {
              this.filters = this.preset.roleLimit.filters
              this.presetFilterSet = this.preset.roleLimit.filters
            }
          }

          if (!this.preset.isOpen) {
            // not open, so check roles and groups

            if (
              this.preset.roleLimit.roles &&
              this.preset.roleLimit.roles.length > 0
            ) {
              // we have roles

              this.scope = "only";
              let allRoles = this.allRoles;

              if (allRoles) {
                let selectedRoles = this.selectedRoles;

                this.preset.roleLimit.roles.forEach(function(role) {
                  var select = allRoles.find(function(element) {
                    return element.value === role;
                  });

                  if (select) {
                    selectedRoles.push(select);
                  }
                });
              } else {
                console.warning(
                  "Roles found in preset but allRoles is empty so cannot populate"
                );
              }
            } else {
              this.scope = "any";
            }

            if (
              this.preset.roleLimit.groups &&
              this.preset.roleLimit.groups.length > 0
            ) {
              this.include = "specific";

              // we have groups

              let selectedGroups = this.selectedGroups;

              if (this.preset.roleLimit.groups.length > 50) {
                // for performance... extremely unlikely to be more than 50 selected though

                this.preset.roleLimit.groups.forEach(function(group) {
                  selectedGroups.push({
                    entityId: group,
                    name: "Group with id: " + group
                  })
                })
              } else {
                ChiRhosNextApi.GroupApi.get_1({
                  entityIds: this.preset.roleLimit.groups
                }).then(
                  response => {
                    if (response.data) {
                      selectedGroups = response.data.map(function(e) {
                        return e.entity;
                      })
                    }
                  },
                  error => {
                    console.error(error);
                    error.json().then(body => {
                      this.$toast(body.Message, "error");
                    });
                  }
                );
              }
            } else {
              // not specific, so look up the descedant and ancestor

              if (
                this.preset.roleLimit.includeAncestors &&
                this.preset.roleLimit.includeDescendants
              ) {
                this.include = "all";
              } else if (
                !this.preset.roleLimit.includeAncestors &&
                this.preset.roleLimit.includeDescendants
              ) {
                this.include = "descendants";
              } else if (
                this.preset.roleLimit.includeAncestors &&
                !this.preset.roleLimit.includeDescendants
              ) {
                this.include = "ancestors";
              } else {
                this.include = "current";
              }
            }
          }
        }
      }
    },
    setLimit() {
      // Setup Limit

      if (this.scope === "update") {
        this.limit = null; // limit is null for this group update only
      } else {
        this.limit = {};
        this.limit.isOpen = this.isOpen;

        this.limit.roleLimit = { groups: [], roles: [], filters: null };

        if (this.advancedFilter) {
          if(this.filters) this.limit.roleLimit.filters = this.filters
          if(this.relationshipRequirements)
          {
            this.limit.roleLimit.relationships = this.relationshipRequirements
          }
        }

        if (!this.isOpen) {
          let _roles = this.selectedRoles.map(item => {
            return item.value;
          });

          if (_roles && _roles.length > 0) this.limit.roleLimit.roles = _roles;

          let _groups = this.selectedGroups.map(item => {
            return item.entityId;
          });

          switch (this.include) {
            case "current":
              this.limit.roleLimit.includeAncestors = false;
              this.limit.roleLimit.includeDescendants = false;
              break;
            case "all":
              this.limit.roleLimit.includeAncestors = true;
              this.limit.roleLimit.includeDescendants = true;
              break;
            case "ancestors":
              this.limit.roleLimit.includeAncestors = true;
              this.limit.roleLimit.includeDescendants = false;
              break;
            case "descendants":
              this.limit.roleLimit.includeAncestors = false;
              this.limit.roleLimit.includeDescendants = true;
              break;
            case "specific":
              this.limit.roleLimit.includeAncestors = false;
              this.limit.roleLimit.includeDescendants = false;
              this.limit.roleLimit.groups = _groups;
              break;
            default:
              this.limit.roleLimit.includeAncestors = false;
              this.limit.roleLimit.includeDescendants = false;
              break;
          }
        }
      }

      this.$emit("set-limit", this.limit);
    },
    addGroup(value) {
      var assign = this.selectedGroups.find(function(element) {
        return element.entityId === value.entityId;
      });

      if (assign) {
        this.$toast("Group already assigned", "error");
      } else {
        this.selectedGroups.unshift(value);
      }
    },
    removeGroup(group) {
      var assign = this.selectedGroups.find(function(element) {
        return element.entityId === group.entityId;
      });

      if (!assign) {
        this.$toast("Group not assigned", "error");
      } else {
        this.selectedGroups.splice(this.selectedGroups.indexOf(assign), 1);
      }
    },
    updateFilter(filterSet) {
      this.filters = filterSet;
    },
    generateUUID() { // Public Domain/MIT https://stackoverflow.com/questions/105034/create-guid-uuid-in-javascript
    var d = new Date().getTime()// Timestamp
    var d2 = (performance && performance.now && (performance.now()*1000)) || 0// Time in microseconds since page-load or 0 if unsupported
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
          var r = Math.random() * 16// random number between 0 and 16
          if(d > 0){// Use timestamp until depleted
              r = (d + r)%16 | 0
              d = Math.floor(d/16)
          } else {// Use microseconds since page-load if supported
              r = (d2 + r)%16 | 0
              d2 = Math.floor(d2/16)
          }
          return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16)
      })
    },
    removeRelationship(id)
    {
      var rem = this.relationshipRequirements.find(function(element) {
        return element.id === id
      })

      if (rem) {
        this.relationshipRequirements.splice(this.relationshipRequirements.indexOf(rem), 1);
      }
    },
    addRelationship()
    {
      if(!this.relationshipMinimum && !this.relationshipMaximum)
      {
        this.$toast("You must select either a minimum or a maxiumum", "error")
        return
      }
      if(!this.relationshipOption)
      {
        this.$toast("You must select a relationship option", "error")
        return
      }

      var rel = { 
        option: this.getRelationshipOption(this.relationshipOption), 
        id: this.generateUUID(),
        minimum: this.relationshipMinimum,
        maximum: this.relationshipMaximum, }

      if(this.relationshipOption.charAt(0) === '-')
      {
        rel.isFrom = null
      }
      else if(this.relationshipOption.charAt(0) === 'f')
      {
        rel.isFrom = true
      }
      if(this.relationshipOption.charAt(0) === 'r')
      {
        rel.isFrom = false
      }
      rel.relationshipTypeEntityId = this.relationshipOption.substring(1)

      this.relationshipRequirements.push(rel)
    },
    getRelationshipOption(id)
    {
      var option = this.relationshipTypeOptions.find(function(e) {
        return e.value === id
      })

      return option ? option.text : '(unknown relationship)'
    },
  }
}
</script>

<style lang="scss"></style>
